import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'; // Adjust the import path as needed
import './css/styles.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
